<template>
  <lazy-div>
    <v-container fluid grid-list-sm>
      <v-flex xs12>
        <v-toolbar dense color="grey lighten-3" flat>
          <v-btn text icon color="green">
            <v-icon @click="returnPage()">mdi-keyboard-backspace</v-icon>
          </v-btn>
          <v-toolbar-title class="toolbar-title-custom">Clause No: {{ this.clseNo }} - {{ this.clseTitle }}</v-toolbar-title>
        </v-toolbar>
        <form>
          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-lg>
                      <v-layout row wrap>
                        <v-flex xs6>
                          <v-text-field
                            v-model="filter.polType"
                            :label="label.polType"
                            :error-messages="errors.collect('filter.polType')"
                            data-vv-name="filter.polType"
                            :data-vv-as="label.polType"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" text @click.native="doClearFilters">Clear Filters</v-btn>
                    <v-btn color="primary" text type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
                  </v-card-actions>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </form>
      </v-flex>
      <v-spacer class="mt-2"></v-spacer>
      <v-flex xs12>
        <v-card>
          <v-flex xs12>
            <v-card>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-card-title>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" dark class="mr-2" @click="doNew">
                      New Clause
                      <v-icon right>mdi-plus</v-icon>
                    </v-btn>
                  </v-card-title>
                  <v-flex xs12>
                    <v-card>
                      <v-data-table
                        :headers="headers"
                        :items="items"
                        v-bind:options.sync="pagination"
                        :server-items-length="totalItems"
                        :loading="loading"
                        :footer-props="{ 'items-per-page-options': itemsPerPage }"
                        :no-data-text="noDataText"
                      >
                        <template v-slot:item="row"
                          ><tr>
                            <td class="text-xs-left">{{ row.item.polType }}</td>
                            <td class="text-xs-left">{{ row.item.polTypeDesc }}</td>
                            <td class="text-xs-left">{{ row.item.clseNo }}</td>
                            <td class="text-xs-left">{{ row.item.clseTitle }}</td>
                            <td class="text-xs-left">{{ row.item.defClse }}</td>
                            <td class="table-action-header">
                              <table-action
                                :rowData="row"
                                query
                                @query="doQuery(row.item)"
                                review
                                @review="doReview(row.item)"
                                remove
                                @remove="doPromptRemove(row.item)"
                              ></table-action>
                            </td></tr
                        ></template>
                      </v-data-table>
                    </v-card>
                  </v-flex>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
        </v-card>
      </v-flex>
      <confirm v-model="promptRemove" @ok="doRemove"> Are you sure that you want to delete the selected Clause? {{ deletePolTypeClse }} </confirm>

      <v-dialog v-model="isFlagCheck" persistent width="300">
        <v-card color="primary" dark>
          <v-card-text class="pa-3">
            {{ processMsg }}
            <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-dialog v-model="showPolTypeClseForm" width="800px" persistent>
        <pol-type-clse-form v-if="showPolTypeClseForm" :ids="ids" @close="doClose" @refresh="doInit"></pol-type-clse-form>
      </v-dialog>
    </v-container>
  </lazy-div>
</template>

<script>
import { mapGetters } from 'vuex'
import { expandURI, filterQuery } from '@/utils/ajax'
import MessageMixin from '@/mixins/message'
import { listMixin } from '@/components/reusable/listMixins'
import * as TableConst from '@/mixins/table'
import clone from 'clone'
import PolTypeClseForm from '../form/PolTypeClseForm'

export default {
  data() {
    return {
      headers: [
        { text: 'Policy Type', align: 'left', value: 'polType' },
        { text: 'Policy Type Description', align: 'left', value: 'polTypeDesc' },
        { text: 'Clause No.', align: 'left', value: 'clseNo' },
        { text: 'Clause No. Title', align: 'left', value: 'clseTitle' },
        { text: 'Default Clause', align: 'left', value: 'defClse' },
        TableConst.tableActionHeader
      ],
      promptRemove: false,
      selectedPolTypeClse: undefined,
      deletePolTypeClse: '',
      label: {
        polType: 'Policy Type'
      },
      filter: {
        polType: null,
        clseNo: null
      },
      toogleArray: [false],
      items: [],
      totalItems: 0,
      loading: false,
      tranMode: null,
      pagination: {
        sortDesc: [false],
        page: 1
      },
      isFlagCheck: false,
      showPolTypeClseForm: false,
      ids: {
        clseNo: undefined,
        polTypeClse: 'new',
        branch: undefined,
        polType: undefined,
        clseTitle: undefined,
        createdName: undefined,
        createdDate: null,
        modifiedName: undefined,
        modifiedDate: undefined
      },
      processMsg: ''
    }
  },
  watch: {
    // fetchPolTypeClse: function (value) {
    //   if (value !== false) {
    //     this.doInit()
    //   }
    // },
    pagination: function (value) {
      this.doInit()
    }
  },
  computed: {
    ...mapGetters(['checkAccess']),
    clsemenu() {
      return this.$store.state.docFormatParam.menu
    },
    filteredItems() {
      return this.items.filter((item) => {
        return !this.search || item.polType.toLowerCase().includes(this.search.toLowerCase())
      })
    }
  },
  methods: {
    async doInit() {
      this.filter.clseNo = this.clseNo
      this.loading = true
      const apiURI = this.clsemenu.polTypeClseList
      if (apiURI) {
        this.loading = true
        try {
          const { page, itemsPerPage } = this.pagination
          let expand = {
            page: page - 1,
            size: itemsPerPage,
            options: false
          }
          let messageFilters = clone(this.filter)
          const result = await this.$http.get(
            filterQuery(expandURI(apiURI, expand), messageFilters, this.pagination.sortBy, this.pagination.sortDesc)
          )
          this.items = []
          if (result.data) {
            const { data } = result.data
            this.totalItems = result.data.totalElements
            if (data) {
              data.map((polTypeClse) => {
                const convertList = {
                  polType: polTypeClse.polType,
                  polTypeDesc: polTypeClse.polTypeDesc,
                  clseNo: polTypeClse.clseNo,
                  clseTitle: polTypeClse.clseTitle,
                  defClse: this.formatBoolean(polTypeClse.defClse),
                  createdName: polTypeClse.modifiedName,
                  createdDate: polTypeClse.createdDate,
                  modifiedName: polTypeClse.modifiedName,
                  modifiedDate: polTypeClse.modifiedDate
                }
                this.items.push(convertList)
              })
            }
          }
          this.loading = false
        } catch (err) {
          this.loading = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    doNew() {
      this.showPolTypeClseForm = true
      this.ids.clseNo = this.clseNo
      this.ids.polTypeClse = 'new'
    },
    doReview(data) {
      this.showPolTypeClseForm = true
      this.ids.clseNo = this.clseNo
      this.ids.polTypeClse = 'review'
      this.ids.branch = data.branch
      this.ids.polType = data.polType
      this.ids.clseTitle = this.clseTitle
      this.ids.createdName = data.modifiedName
      this.ids.createdDate = data.createdDate
      this.ids.modifiedName = data.modifiedName
      this.ids.modifiedDate = data.modifiedDate
    },
    doPromptRemove(data) {
      this.processMsg = 'Checking delete...'
      this.isFlagCheck = true
      this.resetMessages()
      if (data) {
        const apiURI = this.clsemenu.checkDeletePolTypeClse
        if (apiURI) {
          const expand = {
            clseNo: data.clseNo,
            polType: data.polType
            // branch: data.branch
          }
          this.$http
            .get(expandURI(apiURI, expand))
            .then((result) => {
              this.isFlagCheck = false
              this.promptRemove = true
              this.selectedPolTypeClse = data
            })
            .catch((err) => {
              const { data } = err.response
              if (data) {
                this.fieldMessage(data)
                this.notify(data)
              }
            })
        }
      }
    },
    async doRemove() {
      if (this.selectedPolTypeClse.clseNo) {
        this.processMsg = 'Processing...'
        this.isFlagCheck = true
        const apiURI = this.clsemenu.deletePolTypeClse
        if (apiURI) {
          const expand = {
            clseNo: this.selectedPolTypeClse.clseNo,
            polType: this.selectedPolTypeClse.polType
            // branch: this.selectedPolTypeClse.branch
          }
          this.$http
            .delete(expandURI(apiURI, expand))
            .then((result) => {
              const data = result.data
              this.notify(data)
              this.promptRemove = false
              this.isFlagCheck = false
              this.doInit()
            })
            .catch((err) => {
              this.promptRemove = false
              const { data } = err.response
              if (data) {
                this.message(data)
              }
            })
        }
      }
    },
    doQuery(data) {
      this.showPolTypeClseForm = true
      this.ids.clseNo = this.clseNo
      this.ids.polTypeClse = 'query'
      this.ids.branch = data.branch
      this.ids.polType = data.polType
      this.ids.clseTitle = this.clseTitle
      this.ids.createdName = data.modifiedName
      this.ids.createdDate = data.createdDate
      this.ids.modifiedName = data.modifiedName
      this.ids.modifiedDate = data.modifiedDate
    },
    doClearFilters() {
      this.filter.polType = null
      this.doInit()
    },
    doFilters() {
      this.doInit()
    },
    doClose() {
      this.showPolTypeClseForm = false
    },
    returnPage() {
      window.history.back()
    }
  },
  props: {
    fetchPolTypeClse: {
      type: Boolean,
      default: false
    },
    clseNo: {
      type: String,
      default: ''
    },
    clseTitle: {
      type: String,
      default: ''
    }
  },
  mixins: [listMixin, MessageMixin],
  components: {
    PolTypeClseForm
  }
}
</script>

<style>
</style>
